module.exports = __webpack_public_path__ + "img/male_employee.508c2db4.svg";